import React, { useCallback, useEffect, useState } from "react";

import "../UserDashboard.css";
// import { useContext } from "react";
// import { AuthInfo } from "../../Context/noteContext";
import {
  gameHistory,
  profileDetails,
} from "../../../GameServices/GameServices";
import { GameDataContext } from "../../Context/GameDataContext";
import { useContext } from "react";

export function UseDashboardHook() {
  const [referralLink, setReferralLink] = useState("");
  const [copied, setCopied] = useState(false);
  const [gameHistoryData, setGameHistoryData] = useState([]);
  const [Details, setDetails] = useState([]);
  const { user_data, gameDispatch } = useContext(GameDataContext);
  const walletAddress = localStorage.getItem("user_id");
  let { challenges } = gameHistoryData;

  useEffect(() => {
    setReferralLink(localStorage?.getItem("refferralLink"));
    callGameHistory();
    // let id = localStorage.getItem("user_id");
    // fetchProfileDetails(id);
  }, []);

  const fetchProfileDetails = useCallback(
    async (id, page, perpage) => {
      let response = await profileDetails(id, page, perpage);
      // console.log("profile details", response)
      setDetails(response.data);
    },
    [Details]
  );

  const callGameHistory = async () => {
    let player_id = localStorage.getItem("user_id");
    let { data } = await gameHistory(player_id);
    setGameHistoryData(data);
  };

  const copyTextHandler = (param) => {
    switch (param) {
      case "wallet":
        navigator.clipboard.writeText(walletAddress);
        break;
      case "referlink":
        navigator.clipboard.writeText(referralLink);
        break;
      default:
        break;
    }
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return {
    referralLink,
    copyTextHandler,
    copied,
    challenges,
    Details,
    walletAddress,
    fetchProfileDetails,
  };
}
